























import { defineComponent, ref } from "@vue/composition-api";
import useModal from "@/hooks/useModal";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "AgeConfirm",
  components: { BaseButton },
  setup() {
    const show = ref(true);
    useModal(show, false);

    return {
      show,
    };
  },
});
